import React, { useState } from "react";
import Modal from '../shared/simple-modal';
import Form from './form';

const QuoteButton = ({ config }) => {
	
	const [modal, showModal] = useState(false);

	return (
		<>
		
		<a 
			className={config.className}
			onClick={( e ) => {
				e.preventDefault()
				showModal( true )
			}}
		>
			<p className={`bold ${config.color}`}>{config.text}</p>
			<span className={`icon icon-arrow-right ${config.color} right`}></span>
		</a>
		
		
		{modal ? (
			<Modal 
				onClose={() => showModal(false)}
				title={config.title}
			>
				<Form config={config} />
			</Modal>
		) : null}
		</>
	)
}


export default QuoteButton;